import { render, staticRenderFns } from "./ResultTable.vue?vue&type=template&id=55f4f10e&scoped=true&"
import script from "./ResultTable.vue?vue&type=script&lang=js&"
export * from "./ResultTable.vue?vue&type=script&lang=js&"
import style0 from "./ResultTable.vue?vue&type=style&index=0&id=55f4f10e&scoped=true&lang=css&"
import style1 from "./ResultTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4f10e",
  null
  
)

export default component.exports